<template>
    <section class="checkout-header__wrapper">

        <button class="checkout-header__button" v-if="$vuetify.breakpoint.xsOnly" @click="$router.back()">
            <v-icon color="primary" class>mdi-chevron-left</v-icon>
            <span>Back</span>
        </button>

        <h2 class="checkout-header__title">
            Checkout
        </h2>


    </section>
</template>

<script>

import {defineComponent} from "vue";

export default defineComponent({
    components: {}
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.checkout-header {
  &__wrapper {
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 22px;
  }

  &__button {
    width: 78px;
    height: 30px;
    background: #f6f6f6;
    color: #530d69;
    border-radius: 5px;
    margin-top: -10px;
  }

  &__title {
    color: #530d69;
    margin: 28px 0 37px 59.6px;
    font-size: 22px;
    font-weight: bold;
    padding: 0;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .checkout-header {
    &__wrapper {
      background: unset;
    }

    &__title {
      margin: 10px 0 37px 0;
    }
  }
}


</style>